/** Host accounting authority for official Pi; a changed tuple requires a new revision.
 * Evidence: byok-sdk 0962f14f tasks/runs/20260925-official-pi-c-reprobe.json.
 * SDK independently attests installed runtime bytes; this policy never overrides measurement.
 */
export const SaleskoPiAccountingRulingRevision = "salesko.pi-accounting-ruling.2026-09-25.1" as const;

export const SaleskoPiAccountingRulingRuntimeTuple = Object.freeze({
  "packageName": "@earendil-works/pi-coding-agent",
  "packageVersion": "0.87.1",
  "tarballIntegrity": "sha512-m8ArJUtVcQMSe1lLE/Ei7vX/JV7O39sWmWBsXV2NOU70F0qCp8GubA24pT3LnwTmM6LL2xV80/h6sQg85n69ew==",
  "upstreamCommit": "f07218c4d4bbc12bef056a7058c3dd49dfe41abe",
  "provenanceDigest": "db69a280504639d75d269d386bef7f49d18c722733bc2beb18d3b75f56b86517",
  "closureDigest": "33ee3e426437c4bfd9fb50c06252c1ccd8196aa97729f93f00e6a14a289e5ab2",
  "compilerVersion": 4,
  "envelopeFormat": "byok.pi.prepared-input",
  "requestFormat": "byok.pi.openai-completions.request"
} as const);

/** Worker-safe spelling, bound to the SDK 0.22.0 identity spelling and official closure. */
export const SaleskoPiAccountingRulingRuntime = `${SaleskoPiAccountingRulingRuntimeTuple.packageName}@${SaleskoPiAccountingRulingRuntimeTuple.packageVersion}+${SaleskoPiAccountingRulingRuntimeTuple.closureDigest}.compiler-${SaleskoPiAccountingRulingRuntimeTuple.compilerVersion}`;

export const SaleskoPiAccountingRulingTarget = Object.freeze({
  endpoint: "https://api.z.ai/api/coding/paas/v4",
  modelId: "glm-5.3-flash",
});

/** Envelope v4: P(D) is the complete captured body; there are no residual keys. */
export const SaleskoPiAccountingRuledResidualKeys: readonly string[] = Object.freeze([]);

export const SaleskoPiAccountingRuling = Object.freeze({
  revision: SaleskoPiAccountingRulingRevision,
  ruledRuntime: SaleskoPiAccountingRulingRuntime,
  runtime: SaleskoPiAccountingRulingRuntimeTuple,
  envelopeVersion: 4,
  projection: "complete_request_body",
  ruledTarget: SaleskoPiAccountingRulingTarget,
  ruledResidualKeys: SaleskoPiAccountingRuledResidualKeys,
  // MCP tools/list for the fixed Chat toolsets, generated by the device's own
  // registration path and key-sorted canonical JSON. Per-device manifest identity
  // is deliberately excluded (Amendment 1 Errata 1, E2).
  requiredToolsets: Object.freeze(["salesko.read.v1", "salesko.propose.v1"] as const),
  toolsetSchemaDigest: "sha256:1f689f5c90c0e87f4bbfb7408560e43c6632fef83fe2b0f6722556a222c686c9",
  effectiveWindow: 1_000_000,
  additionalOverheadTokenUpperBound: 1_024,
  maxTokens: 131_072,
});

/** Worker-safe projection: the SDK wire checks applicability, not Host budget numbers. */
export const SaleskoPiAccountingPolicyRef = Object.freeze({
  revision: SaleskoPiAccountingRuling.revision,
  ruledRuntime: SaleskoPiAccountingRuling.ruledRuntime,
  ruledTarget: SaleskoPiAccountingRuling.ruledTarget,
  ruledResidualKeys: SaleskoPiAccountingRuling.ruledResidualKeys,
});
